export default __webpack_public_path__ + "static/media/abc-seguros.fb9c14b7.png";